import { Menu, Plus, User } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import NotificationsMenu from './NotificationsMenu'
import GlobalSearch from './GlobalSearch'

export default function Header({ onMenuClick, sidebarCollapsed, onToggleSidebar }) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [showUserMenu, setShowUserMenu] = useState(false)

  return (
    <header className="h-16 glass border-b border-gray-100 sticky top-0 z-30">
      <div className="h-full px-4 lg:px-6 flex items-center justify-between gap-4">
        {/* Left: Menu mobile + Search */}
        <div className="flex items-center gap-3 flex-1 max-w-2xl">
          {/* Mobile menu button */}
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <Menu className="w-5 h-5 text-gray-600" />
          </button>

          {/* Global Search */}
          <div className="flex-1">
            <GlobalSearch />
          </div>
        </div>

        {/* Right: Actions + User */}
        <div className="flex items-center gap-2 lg:gap-3">
          {/* New project button */}
          <button
            onClick={() => navigate('/projects')}
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-white
                     rounded-lg font-semibold text-sm transition-all duration-200
                     hover:bg-primary-600 hover:-translate-y-0.5 hover:shadow-md
                     active:translate-y-0"
          >
            <Plus className="w-4 h-4" />
            <span className="hidden md:inline">Nouveau projet</span>
          </button>

          {/* Notifications */}
          <NotificationsMenu />

          {/* User menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center gap-3 p-1.5 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="hidden lg:block text-right">
                <div className="text-sm font-semibold text-gray-900">
                  {user?.firstName} {user?.lastName}
                </div>
                <div className="text-xs text-gray-500 capitalize">
                  {user?.role?.replace('_', ' ')}
                </div>
              </div>
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary-500 to-secondary-500
                           flex items-center justify-center text-white font-bold text-sm shadow-sm">
                {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
              </div>
            </button>

            {/* Dropdown menu */}
            {showUserMenu && (
              <>
                <div
                  className="fixed inset-0 z-10"
                  onClick={() => setShowUserMenu(false)}
                />
                <div className="absolute right-0 top-full mt-2 w-56 glass border border-gray-100 rounded-lg shadow-lg z-20 py-2 animate-slide-down">
                  <div className="px-4 py-3 border-b border-gray-100">
                    <div className="text-sm font-semibold text-gray-900">
                      {user?.firstName} {user?.lastName}
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5">{user?.email}</div>
                  </div>
                  <button
                    onClick={() => {
                      navigate('/settings')
                      setShowUserMenu(false)
                    }}
                    className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center gap-2"
                  >
                    <User className="w-4 h-4" />
                    Paramètres
                  </button>
                  <hr className="my-1 border-gray-100" />
                  <button
                    onClick={() => {
                      logout()
                      setShowUserMenu(false)
                    }}
                    className="w-full px-4 py-2 text-left text-sm text-danger hover:bg-danger/5 transition-colors"
                  >
                    Déconnexion
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
